import { UI, HStack } from '@genial/components';
import { Typography } from '@genial/design-tokens';
import React from 'react';

export interface ProductCardItemProps {
  label: string;
  value: string | React.ReactNode;
  loading?: boolean;
}

export const ProductCardItem: React.FC<ProductCardItemProps> = ({ label, value, loading }) => {
  const isValueString = typeof value === 'string';

  return (
    <HStack justifyContent="space-between" space={'inline.quarck'}>
      <UI.Text fontSize={Typography['fontsize.xs']}>{label}</UI.Text>
      {isValueString ? (
        <UI.Text
          maxW={{ base: '200px', sm: '2/3' }}
          variant="semibold"
          textAlign="right"
          isLoading={loading}>
          {value}
        </UI.Text>
      ) : (
        value
      )}
    </HStack>
  );
};
